import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { getCustomAxios } from '../helpers';
import { useConfigurationContext } from './ConfigurationContext';
import { jsx as _jsx } from "react/jsx-runtime";
export var SocialMediaContext = /*#__PURE__*/createContext(undefined);
export var SocialMediaContextProvider = function SocialMediaContextProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      allowedExternalProviders = _useState2[0],
      setAllowedExternalProviders = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      forgottenPassChoices = _useState4[0],
      setForgottenPassChoices = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isFetchingSMC = _useState6[0],
      setIsFetchingSMC = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isSMCDataFetched = _useState8[0],
      setIsSMCDataFetched = _useState8[1];

  var _useConfigurationCont = useConfigurationContext(),
      currentLanguage = _useConfigurationCont.currentLanguage;

  var fetchSocialMediaConfiguration = useCallback(async function () {
    if (isFetchingSMC || isSMCDataFetched) {
      return;
    }

    setIsFetchingSMC(true);

    var _await$getCustomAxios = await getCustomAxios(currentLanguage).get('/system/ajax/LoginApi/GetConfiguration'),
        data = _await$getCustomAxios.data;

    setAllowedExternalProviders(data.AllowedExternalProviders);
    setForgottenPassChoices(data.ForgottenPasswordChannelChoices);
    setIsFetchingSMC(false);
    setIsSMCDataFetched(true);
  }, [isFetchingSMC, isSMCDataFetched, currentLanguage]);
  var value = useMemo(function () {
    return {
      allowedExternalProviders: allowedExternalProviders,
      forgottenPassChoices: forgottenPassChoices,
      fetchSocialMediaConfiguration: fetchSocialMediaConfiguration
    };
  }, [allowedExternalProviders, forgottenPassChoices, fetchSocialMediaConfiguration]);
  return /*#__PURE__*/_jsx(SocialMediaContext.Provider, {
    value: value,
    children: children
  });
};
export var useSocialMediaContext = function useSocialMediaContext() {
  var context = useContext(SocialMediaContext);

  if (context) {
    return context;
  }

  throw new Error('SocialMediaContext value must be set.');
};